import type { CorrectComponentType } from "/npm/@brytdesigns/web-component-utils@0.1.7";

import {
  type ValidHybridPath,
  provideFullPropertyPathContext,
  useFullPropertyPath,
} from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/index.js";

type CartDataArrayItemProps = {
  itemIndex: ValidHybridPath;
};

export const CartDataArrayItem: CorrectComponentType<CartDataArrayItemProps> = (
  props,
  { element },
) => {
  if (!props.itemIndex)
    return console.warn("cart-data-array-item: No path attribute provided.");
  const mergedProps = {
    element,
    path: () => props.itemIndex,
  };
  const fullPath = useFullPropertyPath(mergedProps);
  provideFullPropertyPathContext({
    element,
    path: fullPath,
  });
};
